import { jsx as _jsx } from "react/jsx-runtime";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import List from "components/Lists/List";
const { news: { GET_OUTLETS, SEARCH_OUTLETS } } = queries;
const { news: { DELETE_OUTLET } } = mutations;
const OutletsList = () => (_jsx(List, { deleteMutation: DELETE_OUTLET, hasSearch: true, itemNamePlural: "outlets", label: "Outlets", listQuery: GET_OUTLETS, listQueryDataName: "getOutlets", pathPrefix: "/news", searchQuery: SEARCH_OUTLETS, searchQueryDataName: "searchOutlets", searchQueryInputName: "searchOutletsInput", searchQueryPropertyName: "name" }));
export default OutletsList;
